import React from 'react'
import { getImgProps, Link } from '@superhi/design'

import HighlightsComponent from 'src/components/Highlights'
import { buildPath } from 'src/routing'

const IMG_SIZE = {
  small: 100,
  medium: 50,
  large: 50,
  xlarge: 50,
}
const IMG_CONFIG: Parameters<typeof getImgProps>[2] = {
  fm: 'png8',
}

const DATA: React.ComponentProps<typeof HighlightsComponent>['items'] = [
  {
    title: 'Is it right for us?',
    subtitle:
      'You don’t need to be a business in the traditional sense. Whether you’re looking to upskill staff in technical creative skills or you’re a group of people who want to make things online, it’s right for you!',
    image: {
      ...getImgProps(
        'https://superhi.s3.amazonaws.com/assets/images/teams/courses.png',
        IMG_SIZE,
        IMG_CONFIG,
      ),
      alt: 'A 3D illustration showing six rectangular labels with SuperHi course names on them, overlapped by rectangular shapes. In the background are more shapes in primary colours.',
    },
  },
  {
    title: 'Tailored learning paths',
    subtitle: (
      <>
        <span>
          Let us know your needs and we&rsquo;ll work out a custom learning path for each person. We
          have
        </span>
        <Link href={buildPath('courses-index')}> 25+ courses </Link>
        <span>spanning design, code, and project management, from beginner to advanced level.</span>
      </>
    ),
    image: {
      ...getImgProps(
        'https://superhi.s3.amazonaws.com/assets/images/teams/paths.png',
        IMG_SIZE,
        IMG_CONFIG,
      ),
      alt: 'A 3D illustration showing two pieces of lined paper, each showing a checklist of creative goals, indicating tailored individual learning paths for team members. They are surrounded by shapes in primary colours.',
    },
  },
  {
    title: 'Custom team workshops',
    subtitle:
      'Want us to host a team-building workshop with one of our design or coding experts? We can discuss topics with you and schedule it in!',
    image: {
      ...getImgProps(
        'https://superhi.s3.amazonaws.com/assets/images/teams/workshops.png',
        IMG_SIZE,
        IMG_CONFIG,
      ),
      alt: "A 3D illustration with three calendar cards showing details of members' events. They are surrounded by coloured shapes.",
    },
  },
]

const Highlights: React.FC<React.PropsWithChildren<unknown>> = () => (
  <HighlightsComponent items={DATA} />
)

export default Highlights
